import { render, staticRenderFns } from "./WeeklyTest.vue?vue&type=template&id=461daf62"
import script from "./WeeklyTest.vue?vue&type=script&lang=js"
export * from "./WeeklyTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports